var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("reference-point"),
        state: _vm.getState(_vm.$v.recipient.reference_point),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.reference_point),
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          name: "reference-point",
          readonly: _vm.disabled,
          disabled: _vm.disabled,
        },
        on: { input: () => _vm.$v.recipient.reference_point.$touch() },
        model: {
          value: _vm.recipient.reference_point,
          callback: function ($$v) {
            _vm.$set(_vm.recipient, "reference_point", $$v)
          },
          expression: "recipient.reference_point",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }